import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiMessageSquare } from "react-icons/fi";
import { baseUrl } from "../../Environments/environment";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment-timezone";
import { Tick } from "../../icons/Tick";
import houseKeeping from "../../icons/houseKeeping.png";
import {
	addSelectedAddOn,
	filterAddOnRequests,
	filterCheckInOutRequsts,
	setAllAddOns,
	setEarlyCheckInTime,
	setGuestAddons,
	setGuestCheckInOutRequests,
	setLateCheckOutTime,
	filterHouseKeepingRequest,
} from "../../redux/addOn/addOnSlice";
import DateandTimePicker from "../CheckIn/Addon/DateandTimePicker";
import LateCheckoutTimePicker from "../CheckIn/Addon/LateCheckoutTimePicker";
import HouseKeepingService from "../Services/HouseKeepingService";
import HouseKeepingRequestAddOn from "../Services/HouseKeepingRequestAddOn";
import { Bounce, toast, ToastContainer } from "react-toastify";
import BottomSheetModal from "../CheckIn/PreArrivalCheckin/BottomSheetModal";
import { isOutsideServiceHours } from "../../utils/housekeeping";
const getFormattedDate = () => {
	const today = new Date();
	const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11, so add 1
	const day = String(today.getDate()).padStart(2, "0");
	const year = today.getFullYear();

	return `${month}/${day}/${year}`;
};
const convert24to12 = (time24) => {
	try {
		return moment(time24, "HH:mm").format("hh:mm A");
	} catch (error) {
		console.error("Error converting 24h to 12h format:", error);
		return "";
	}
};
const convert12to24 = (time12) => {
	try {
		return moment(time12, "hh:mm A").format("HH:mm");
	} catch (error) {
		console.error("Error converting 12h to 24h format:", error);
		return "";
	}
};
const ServiceContainer = ({
	heading,
	name,
	number,
	onClose,
	propertyMobile,
}) => {
	const guestid = useParams();
	const guestSessionId = guestid.id;
	const navigate = useNavigate();
	const [guest, setGuest] = useState("");
	const [houseKeepingRequests, setHouseKeepingRequests] = useState([]);
	const [upgradeRoomRequests, setUpgradeRoomRequests] = useState([]);
	const [addOns, setAddOns] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [requestSentStatus, setRequestSentStatus] = useState({}); // Object to track requestSent status for each add-on
	const [selectedAddOn, setSelectedAddOn] = useState(null); // Store selected add-on for the modal
	const [propertyCheckInTime, setPropertyCheckInTime] = useState("");
	const [propertyCheckOutTime, setPropertyCheckOutTime] = useState("");
	const [propertyEarlyCheckInTime, setPropertyEarlyCheckInTime] = useState("");
	const [propertyLateCheckOutTime, setPropertyLateCheckOutTime] = useState("");
	const [propertyTimeZone, setPropertyTimeZone] = useState(null);
	const [selectedTime, setSelectedTime] = useState(propertyCheckInTime);
	const [selectedDate, setSelectedDate] = useState(getFormattedDate());
	const [isLoading, setIsLoading] = useState(false);
	const [requestStatus, setRequestStatus] = useState(null);
	const [preArrivalFlow, setPreArrivalFlow] = useState(null);
	const [arrivalTime, setArrivalTime] = useState("");
	const [loadingAddOnId, setLoadingAddOnId] = useState(null);
	const [showEarlyCheckInButton, setShowEarlyCheckInButton] = useState(false);
	const [lateCheckoutRequestStatus, setlateCheckoutRequestStatus] =
		useState(null);
	const [isHouseKeepingModalOpen, setIsHouseKeepingModalOpen] = useState(false);
	const [lateCheckoOutSelectedTime, setLateCheckoOutSelectedTime] =
		useState("");
	const [showLateCheckOutButton, setShowLateCheckOutButton] = useState(false);
	const [isLateCheckOutModalOpen, setIsLateCheckOutModalOpen] = useState(false);
	const [lateCheckOutFlag, setLateCheckOutFlag] = useState(false);
	const [isLateCheckOutLoading, setIsLateCheckOutLoading] = useState(false);
	const [selectedHouseKeepingOptions, setSelectedHouseKeepingOptions] =
		useState([]);
	const [sentHouseKeepingRequest, setSentHouseKeepingRequest] = useState(false);
	const [isUpgradeRoomModalOpen, setIsUpgradeRoomModalOpen] = useState(false);
	const [selectedUpgradeRoomOption, setSelectedUpgradeRoomOption] =
		useState(null);
	const [upgradeRoomRequestStatus, setUpgradeRoomRequestStatus] =
		useState(null);

	const storeAddOns = useSelector((state) => state.addOn);

	const dispatch = useDispatch();
	const handleHouseKeepingOptionChange = (e) => {
		if (e.target.checked) {
			setSelectedHouseKeepingOptions([
				...selectedHouseKeepingOptions,
				e.target.value,
			]);
		} else {
			setSelectedHouseKeepingOptions(
				selectedHouseKeepingOptions.filter(
					(option) => option !== e.target.value,
				),
			);
		}
	};
	const handleSendHouseKeepingRequest = async () => {
		const houseKeeping = addOns.find((item) => {
			if (item.name === "House Keeping") return item;
		});
		if (
			houseKeeping.options.length !== 0 &&
			selectedHouseKeepingOptions.length === 0
		) {
			toast.error("Please select at least one option");
			return;
		}
		setIsLoading(true);
		setLoadingAddOnId(houseKeeping._id);
		try {
			const data = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
				{
					type: "houseKeeping",
					name: "House Keeping",
					description: "House Keeping Service Request",
					options: selectedHouseKeepingOptions,
				},
			);
			if (data.status === 200) {
				toast.success("Request sent successfully");
				setSentHouseKeepingRequest(true);
				// dispatch(filterHouseKeepingRequest(data.data.result));
			}
		} catch (e) {
			toast.error(e.response?.data?.message || "Failed to send request");
			console.error("Housekeeping request error:", e);
		} finally {
			setIsLoading(false);
			setLoadingAddOnId(null);
		}
	};

	const getWorkFlow = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/workflow`,
			);

			setPreArrivalFlow(response.data.result.preArrivalFlow);
			setPropertyCheckInTime(
				response.data.result.settingFlow.standardCheckinTime,
			);
			setArrivalTime(response.data.result.settingFlow.standardCheckinTime);
			setPropertyTimeZone(response.data.result.settingFlow.timezone);
			setPropertyCheckOutTime(
				response.data.result.settingFlow.standardCheckoutTime,
			);
			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[0].enabled
			)
				setPropertyEarlyCheckInTime(
					response.data.result.addOnsFlow.checkInOutAddOns[0],
				);

			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[1].enabled
			)
				setPropertyLateCheckOutTime(
					response.data.result.addOnsFlow.checkInOutAddOns[1],
				);
			const addOnsFlow = response.data.result.addOnsFlow;
			const custAdd = addOnsFlow.customAddOns.filter((item) => item.enabled);
			const tempArr = [...addOnsFlow.checkInOutAddOns, ...custAdd];
			if (guest.status && guest.status.currentStatus === "In House") {
				tempArr.unshift(response.data.result.addOnsFlow.houseKeepingAddOns);
				// Add upgrade room add-on for In House guests
				if (addOnsFlow.upgradeRoom && addOnsFlow.upgradeRoom.enabled) {
					tempArr.unshift(addOnsFlow.upgradeRoom);
				}
				console.log("temp", tempArr);
			}
			console.log("Guest", guest);

			console.log(tempArr);
			setAddOns(tempArr);
			dispatch(setAllAddOns(tempArr));
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	const getGuest = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/guest`,
			);
			setGuest(response.data.result);
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await getGuest();
		};

		fetchData();
	}, []);

	const getGuestCheckInOutRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
			);
			dispatch(setGuestCheckInOutRequests(response.data.result));
			dispatch(filterCheckInOutRequsts(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getGuestAddons = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/addOns`,
			);
			dispatch(filterAddOnRequests(response.data.result));
			dispatch(setGuestAddons(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getHouseKeepingRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
			);

			console.log(response.data.result);
			setHouseKeepingRequests(response.data.result);
			// dispatch(filterHouseKeepingRequest(response.data.result));
			// dispatch(setGuestAddons(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	const getUpgradeRoomRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/upgradeRoomRequest`,
			);
			console.log(response.data.result);
			setUpgradeRoomRequests(response.data.result);
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	useEffect(() => {
		getGuestCheckInOutRequests();
		getGuestAddons();
		getHouseKeepingRequests();
		getUpgradeRoomRequests();
	}, [requestStatus, lateCheckoutRequestStatus, guestSessionId]);
	useEffect(() => {
		getHouseKeepingRequests();
	}, [sentHouseKeepingRequest]);
	useEffect(() => {
		getUpgradeRoomRequests();
	}, [upgradeRoomRequestStatus]);
	useEffect(() => {
		if (guest && guest.status && guest.status.currentStatus) {
			getWorkFlow();
		}
	}, [guest]);
	useEffect(() => {
		if (selectedTime && selectedTime !== propertyCheckInTime) {
			setShowEarlyCheckInButton(true);
		} else {
			setShowEarlyCheckInButton(false);
		}
	}, [selectedTime, propertyCheckInTime]);
	useEffect(() => {
		if (
			lateCheckoOutSelectedTime &&
			lateCheckoOutSelectedTime !== propertyCheckOutTime
		) {
			setShowLateCheckOutButton(true);
		} else {
			setShowLateCheckOutButton(false);
		}
	}, [lateCheckoOutSelectedTime, propertyCheckOutTime]);
	const [settings, setSettings] = useState(null);
	const fetchSettings = async () => {
		const response = await axios.get(
			`${baseUrl}/guestApi/${guestSessionId}/workflow`,
		);

		setSettings(response.data.result.settingFlow);
	};
	useEffect(() => {
		fetchSettings();
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		getUpgradeRoomRequests();
	}, []);

	const handleSendRequest = (addOn) => {
		setSelectedAddOn(addOn);
		setIsModalOpen(false);
		setIsHouseKeepingModalOpen(false);
		setIsLateCheckOutModalOpen(false);
		setIsUpgradeRoomModalOpen(false);

		if (addOn.name === "Upgrade Room") {
			if (!guest.roomType) {
				toast.error("Your room type details are not provided. Contact front desk.");
				return;
			}
			// Navigate to upgrade room page
			navigate(`/${guestSessionId}/upgrade-room`, {
				state: {
					guest,
					upgradeRoomRequests,
				},
			});
		} else if (addOn.name === "House Keeping") {
			if (!addOns) return; // 👈 IMPORTANT
			const houseKeeping = addOns.find((item) => item.name === "House Keeping");

			if (isOutsideServiceHours(houseKeeping, settings)) {
				toast.error(
					"You’re contacting a service outside business hours. Please reach out to the front desk.",
				);
				return;
			}
			setIsHouseKeepingModalOpen(true);
		} else if (addOn.addOnType != "CustomAddon") {
			setIsModalOpen(true);
		} else {
			handleConfirmRequest(addOn);
		}
	};

	function formatDateTime(date, time) {
		try {
			// Convert the date to the property timezone
			const dateInPropertyTZ = moment(date, "DD-MM-YYYY");

			// Format the date in YYYY-MM-DD format
			const formattedDate = dateInPropertyTZ.format("YYYY-MM-DD");

			// If time is provided, add it to the date
			if (time) {
				// Combine date with time and ensure it's in the property timezone
				const dateTimeString = `${formattedDate}T${time}Z`;
				return dateTimeString;
			}

			// If no time provided, just return the formatted date
			return formattedDate;
		} catch (error) {
			console.error("Error formatting date:", error);
			return null;
		}
	}
	const handleEarlyCheckInAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const earlyCheckInAddon = storeAddOns.allAddOns.find((item) =>
			item.name.toLowerCase().includes("early check in"),
		);
		console.log("earlyCheckInAddon", earlyCheckInAddon);
		const data = {
			earlyCheckInDateTime: formatDateTime(
				moment(guest.checkIn).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "earlyCheckIn",
			checkInOutRequestId: earlyCheckInAddon._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(earlyCheckInAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(earlyCheckInAddon));
				toast.success("Request sent successfully");
				// console.log("Request sent successfully!");
			} else {
				setRequestStatus("failure"); // Update the request status to failure
				// console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setRequestStatus("failure"); // Update the request status to failure
			console.log(error);
			// toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false); // Ensure loading state is reset
		}
	};

	const handleLateCheckOutAddon = async (time) => {
		const formattedTime = convert12to24(time);
		const lateCheckOutAddon = storeAddOns.allAddOns.find((item) =>
			item.name.toLowerCase().includes("late check out"),
		);
		const data = {
			lateCheckOutDateTime: formatDateTime(
				moment(guest.checkOut).format("DD-MM-YYYY"),
				formattedTime,
			),
			requestType: "lateCheckOut",
			checkInOutRequestId: lateCheckOutAddon._id,
		};
		try {
			setIsLateCheckOutLoading(true);
			setLoadingAddOnId(lateCheckOutAddon._id);
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
				data,
			);

			if (response.status === 200) {
				setlateCheckoutRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(lateCheckOutAddon));
				toast.success("Request sent successfully");
				// dispatch(setLateCheckOutTime(time));
				//    console.log("Request sent successfully!");
			} else {
				setlateCheckoutRequestStatus("failure"); // Update the request status to failure
				//  console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setlateCheckoutRequestStatus("failure"); // Update the request status to failure
			console.log(error);
			//toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLateCheckOutLoading(false); // Ensure loading state is reset
		}
	};
	const handleConfirmRequest = async (addOn) => {
		await sendRequestToBackend(addOn);

		setIsModalOpen(false); // Close modal
	};

	const sendRequestToBackend = async (selectedAddOn) => {
		console.log("sendRequestToBack", selectedAddOn);
		const data = {
			addOnsId: selectedAddOn._id,
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(selectedAddOn._id);
			setRequestStatus("idle");
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/addOnsRequest`,
				data,
			);
			if (response.status === 201) {
				setRequestStatus("success"); // Update the request status to success
				dispatch(addSelectedAddOn(selectedAddOn));
				toast.success("Request sent successfully");
				// console.log("Request sent successfully!");
			} else {
				setRequestStatus("failure"); // Update the request status to failure
				// console.log("Request failed. Please try again.");
			}
		} catch (error) {
			setRequestStatus("failure"); // Update the request status to failure
			console.log(error);
			//toast.error("Request failed. Please try again.");
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false); // Ensure loading state is reset
		}
	};

	const handleUpgradeRoomSubmit = async () => {
		if (!selectedUpgradeRoomOption) return;
		// Find the selected option object
		const optionObj = selectedAddOn.options.find(
			(opt) => opt._id === selectedUpgradeRoomOption,
		);
		const optionText = optionObj
			? `${optionObj.roomNumber} - ${optionObj.roomType}`
			: "";
		const data = {
			type: "upgradeRoom",
			name: "Upgrade Room",
			description: "Upgrade to a better room type.",
			options: [optionText],
		};
		try {
			setIsLoading(true);
			setLoadingAddOnId(selectedAddOn._id);
			setRequestStatus("idle");
			const response = await axios.post(
				`${baseUrl}/guestApi/${guestSessionId}/houseKeepingRequest`,
				data,
			);
			if (response.status === 200) {
				setRequestStatus("success");
				dispatch(addSelectedAddOn(selectedAddOn));
				setIsUpgradeRoomModalOpen(false);
				setSelectedUpgradeRoomOption(null);
				toast.success("Upgrade Room request sent successfully");
			} else {
				setRequestStatus("failure");
				toast.error("Request failed. Please try again.");
			}
		} catch (error) {
			setRequestStatus("failure");
			toast.error("Request failed. Please try again.");
			console.log(error);
		} finally {
			setLoadingAddOnId(null);
			setIsLoading(false);
		}
	};

	return (
		<div className=" p-4 rounded-lg shadow-lg text-white w-full flex-shrink-0">
			<div className="flex flex-row justify-between items-center w-[100%]">
				<div className="text-[#FFFFFF] font-poppins font-light text-[22px]">
					Our Services
				</div>
				{/* <div
          className="text-[#FFFFFF] font-poppins font-light text-xs underline  decoration-white underline-offset-2 decoration-2"
          // onClick={() => setBottomSheetOpen(true)}
        >
          View All
        </div> */}
			</div>
			<div className="mt-4 overflow-x-auto">
				{guest && (
					<div className="flex space-x-4 pb-4">
						{storeAddOns.allAddOns.map((addOn) => {
							if (addOn.name?.toLowerCase().includes("early")) {
								if (guest.status.currentStatus !== "Reservation") {
									return <></>;
								}
							}
							if (addOn.name?.toLowerCase().includes("upgrade room")) {
								if (!guest.roomNumber) {
									return <></>;
								}
							}
							return (
								<div
									key={addOn._id}
									className="w-64 flex-shrink-0 bg-gray-700 rounded-md p-4 transform transition-transform hover:scale-105 "
								>
									<div className="mb-2 rounded-md">
										<img
											src={(() => {
												if (addOn.name?.toLowerCase().includes("early")) {
													return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/early+check+in.png";
												} else if (addOn.name?.toLowerCase().includes("late")) {
													return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/late+check+out.png";
												} else if (addOn.name === "House Keeping") {
													return houseKeeping;
												} else if (
													addOn.name?.toLowerCase().includes("upgrade room")
												) {
													return "https://onelyk-images-bucket.s3.us-east-1.amazonaws.com/addOns/upgrade-room.png";
												} else if (addOn.image) {
													return addOn.image;
												} else {
													return "https://st3.depositphotos.com/1022597/35608/i/450/depositphotos_356083076-stock-photo-grey-stone-texture-useful-background.jpg";
												}
											})()}
											className="w-full h-36 object-cover rounded-md"
										/>
									</div>
									<div className="flex justify-between mb-2">
										<div className="text-lg font-semibold">{addOn.name}</div>
										<div className="text-lg font-semibold">
											{!addOn.paid ||
											addOn.price === undefined ||
											addOn.price === 0
												? ""
												: `$${addOn.price}`}
										</div>
									</div>
									{addOn?.addonNote ? (
										<div className="text-yellow-500 mb-2 text-sm h-12 overflow-hidden">
											{addOn?.description &&
												`${addOn.addonNote.slice(0, 50)}...`}
										</div>
									) : (
										<div className="text-gray-300 mb-2 text-sm h-12 overflow-hidden">
											{addOn?.description &&
												`${addOn.description.slice(0, 50)}...`}
										</div>
									)}
									{/* Request handling logic remains the same as in the original code */}
									{addOn.addOnType !== "CustomAddon" ? (
										addOn.name.toLowerCase().includes("upgrade room") ? (
											// Upgrade Room logic
											<>
												{upgradeRoomRequests.length > 0 &&
												upgradeRoomRequests.some(
													(request) => request.requestStatus === "Requested",
												) ? (
													<button
														className="mt-1 w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
														disabled
													>
														<span className="mr-2">
															<Tick />
														</span>
														Request Sent
													</button>
												) : (
													<button
														className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
														onClick={() => handleSendRequest(addOn)}
													>
														Select Room
													</button>
												)}
											</>
										) : addOn.name.toLowerCase().includes("early") ? (
											// Early check-in logic
											<>
												{/* <input
                          type="text"
                          value={
                            storeAddOns?.guestCheckInOutRequests?.find(
                              (selectedAddOn) =>
                                selectedAddOn.requestType === "earlyCheckIn",
                            )
                              ? new Date(
                                  storeAddOns.guestCheckInOutRequests.find(
                                    (selectedAddOn) =>
                                      selectedAddOn.requestType ===
                                      "earlyCheckIn",
                                  ).earlyCheckInDateTime,
                                ).toLocaleString("en", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                  timeZone: "UTC",
                                })
                              : selectedTime ||
                                convert24to12(
                                  propertyEarlyCheckInTime?.customTiming ||
                                    propertyEarlyCheckInTime?.defaultTiming,
                                )
                          }
                          readOnly
                          disabled={
                            storeAddOns &&
                            storeAddOns.guestCheckInOutRequests.length > 0 &&
                            storeAddOns.guestCheckInOutRequests.some(
                              (selectedAddOn) =>
                                selectedAddOn.requestType === "earlyCheckIn" &&
                                ["Requested", "Accepted"].includes(
                                  selectedAddOn.requestStatus,
                                ),
                            )
                          }
                          onClick={() => {
                            console.log("onClick");
                            setIsModalOpen(true);
                          }}
                          className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        /> */}
												{!(
													storeAddOns &&
													storeAddOns.guestCheckInOutRequests.length > 0 &&
													storeAddOns.guestCheckInOutRequests.some(
														(selectedAddOn) =>
															selectedAddOn.requestType === "earlyCheckIn" &&
															selectedAddOn.requestStatus === "Requested",
													)
												) && loadingAddOnId !== addOn._id && (
													<button
														onClick={() => setIsModalOpen(true)}
														className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 py-2 rounded-lg shadow-md focus:outline-none focus:shadow-outline bg-indigo-600 text-white border-gray-50 hover:bg-indigo-400"
													>
														Send Request
													</button>
												)}
												{loadingAddOnId === addOn._id && (
													<button
														className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
														onClick={() => handleSendRequest(addOn)}
														disabled={loadingAddOnId === addOn._id}
													>
														{loadingAddOnId === addOn._id && (
															<>
																<svg
																	className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																	xmlns="http://www.w3.org/2000/svg"
																	fill="none"
																	viewBox="0 0 24 24"
																>
																	<circle
																		className="opacity-25"
																		cx="12"
																		cy="12"
																		r="10"
																		stroke="currentColor"
																		strokeWidth="4"
																	/>
																	<path
																		className="opacity-75"
																		fill="currentColor"
																		d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																	/>
																</svg>
																Processing...
															</>
														)}
													</button>
												)}

												{storeAddOns?.guestCheckInOutRequests?.some(
													(selectedAddOn) =>
														selectedAddOn.requestType === "earlyCheckIn" &&
														selectedAddOn.requestStatus === "Requested",
												) && (
													<button
														className="mt-1 w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
														disabled
													>
														<span className="mr-2">
															<Tick />
														</span>
														Request Sent
													</button>
												)}
											</>
										) : addOn.name.toLowerCase().includes("late") ? (
											<>
												{/* <input
                          type="text"
                          value={
                            storeAddOns?.guestCheckInOutRequests?.find(
                              (selectedAddOn) =>
                                selectedAddOn.requestType === "lateCheckOut",
                            )
                              ? new Date(
                                  storeAddOns.guestCheckInOutRequests.find(
                                    (selectedAddOn) =>
                                      selectedAddOn.requestType ===
                                      "lateCheckOut",
                                  ).lateCheckOutDateTime,
                                ).toLocaleString("en", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,

                                  timeZone: "UTC",
                                })
                              : selectedTime ||
                                convert24to12(
                                  propertyLateCheckOutTime?.customTiming ||
                                    propertyLateCheckOutTime?.defaultTiming,
                                )
                          }
                          readOnly
                          disabled={
                            storeAddOns &&
                            storeAddOns.guestCheckInOutRequests.length > 0 &&
                            storeAddOns.guestCheckInOutRequests.some(
                              (selectedAddOn) =>
                                selectedAddOn.requestType === "lateCheckOut" &&
                                ["Requested", "Accepted"].includes(
                                  selectedAddOn.requestStatus,
                                ),
                            )
                          }
                          onClick={() => setIsLateCheckOutModalOpen(true)}
                          className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        /> */}
												{!(
													storeAddOns &&
													storeAddOns.guestCheckInOutRequests.length > 0 &&
													storeAddOns.guestCheckInOutRequests.some(
														(selectedAddOn) =>
															selectedAddOn.requestType === "lateCheckOut" &&
															selectedAddOn.requestStatus === "Requested",
													)
												) && loadingAddOnId !== addOn._id && (
													<button
														onClick={() => setIsLateCheckOutModalOpen(true)}
														className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 py-2 rounded-lg shadow-md focus:outline-none focus:shadow-outline bg-indigo-600 text-white border-gray-50 hover:bg-indigo-400"
													>
														Send Request
													</button>
												)}
												{loadingAddOnId === addOn._id && (
													<button
														className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
														onClick={() => handleSendRequest(addOn)}
														disabled={loadingAddOnId === addOn._id}
													>
														{loadingAddOnId === addOn._id && (
															<>
																<svg
																	className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
																	xmlns="http://www.w3.org/2000/svg"
																	fill="none"
																	viewBox="0 0 24 24"
																>
																	<circle
																		className="opacity-25"
																		cx="12"
																		cy="12"
																		r="10"
																		stroke="currentColor"
																		strokeWidth="4"
																	/>
																	<path
																		className="opacity-75"
																		fill="currentColor"
																		d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																	/>
																</svg>
																Processing...
															</>
														)}
													</button>
												)}
												{storeAddOns?.guestCheckInOutRequests?.some(
													(selectedAddOn) =>
														selectedAddOn.requestType === "lateCheckOut" &&
														selectedAddOn.requestStatus === "Requested",
												) && (
													<button
														className="mt-1 w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
														disabled
													>
														<span className="mr-2">
															<Tick />
														</span>
														Request Sent
													</button>
												)}
											</>
										) : (
											<button
												className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
												onClick={() => handleSendRequest(addOn)}
												disabled={loadingAddOnId === addOn._id}
											>
												{loadingAddOnId === addOn._id ? (
													<>
														<svg
															className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
														>
															<circle
																className="opacity-25"
																cx="12"
																cy="12"
																r="10"
																stroke="currentColor"
																strokeWidth="4"
															/>
															<path
																className="opacity-75"
																fill="currentColor"
																d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
															/>
														</svg>
														Processing...
													</>
												) : houseKeepingRequests.length === 0 ? (
													"Send Request"
												) : (
													"Send New Request"
												)}
											</button>
										)
									) : // Custom add-on logic
									storeAddOns.guestAddons.some(
											(selectedAddOn) =>
												selectedAddOn.addOnsId === addOn._id &&
												selectedAddOn.requestStatus === "Requested",
										) ? (
										<button
											className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
											disabled
										>
											<span className="mr-2">
												<Tick />
											</span>
											Request Sent
										</button>
									) : (
										<button
											className="max-w-sm mx-auto mt-4 flex flex-row items-center justify-center w-full border-2 border-gray-50 py-2 bg-indigo-600 text-white rounded-lg shadow-md hover:bg-indigo-400 focus:outline-none focus:shadow-outline"
											onClick={() => handleSendRequest(addOn)}
											disabled={loadingAddOnId === addOn._id}
										>
											{loadingAddOnId === addOn._id ? (
												<>
													<svg
														className="animate-spin -ml-1 mr-2 h-5 w-5 text-indigo-600"
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
														viewBox="0 0 24 24"
													>
														<circle
															className="opacity-25"
															cx="12"
															cy="12"
															r="10"
															stroke="currentColor"
															strokeWidth="4"
														/>
														<path
															className="opacity-75"
															fill="currentColor"
															d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
														/>
													</svg>
													Processing...
												</>
											) : (
												"Send Request"
											)}
										</button>
									)}
								</div>
							);
						})}
					</div>
				)}
			</div>
			{isModalOpen && (
				<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
					{guest && (
						<DateandTimePicker
							isModalOpen={isModalOpen}
							setIsModalOpen={setIsModalOpen}
							setRequestSent={(time) => {
								setSelectedTime(time);
								//dispatch(setEarlyCheckInTime(time));
								handleEarlyCheckInAddon(time);
							}}
							addon={storeAddOns.allAddOns.find((addon) => {
								if (
									addon.addOnType !== "CustomAddon" &&
									addon.name.toLowerCase().replace(/\s+/g, "").includes("early")
								)
									return addon;
							})}
							date={guest.checkIn}
							propertyEarlyCheckInTime={propertyEarlyCheckInTime}
							propertyTime={propertyCheckInTime}
							propertyTimeZone={propertyTimeZone}
						/>
					)}
				</div>
			)}
			{isHouseKeepingModalOpen && (
				<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
					{guest && (
						<HouseKeepingRequestAddOn
							houseKeeping={addOns.find((item) => {
								if (item.name === "House Keeping") return item;
							})}
							isModalOpen={isHouseKeepingModalOpen}
							setIsModalOpen={setIsHouseKeepingModalOpen}
							handleSendRequest={handleSendHouseKeepingRequest}
							handleOptionChange={handleHouseKeepingOptionChange}
							selectedOptions={selectedHouseKeepingOptions}
						/>
					)}
				</div>
			)}
			{isLateCheckOutModalOpen && (
				<div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
					{guest && (
						<LateCheckoutTimePicker
							isModalOpen={isLateCheckOutModalOpen}
							setIsModalOpen={setIsLateCheckOutModalOpen}
							setRequestSent={(date, time) => {
								setLateCheckoOutSelectedTime(time);
								handleLateCheckOutAddon(time);
								//setSelectedDate(date);
								// setConfirmLateCheckOutRequest(true);
							}}
							addon={storeAddOns.allAddOns.find((addon) => {
								if (
									addon.addOnType !== "CustomAddon" &&
									addon.name.toLowerCase().replace(/\s+/g, "").includes("late")
								)
									return addon;
							})}
							propertyLateCheckOutTime={propertyLateCheckOutTime}
							propertyTime={propertyCheckOutTime}
							checkOutDate={guest.checkOut}
							propertyTimeZone={propertyTimeZone}
							lateCheckOutFlag={true}
						/>
					)}
				</div>
			)}
			{/* {isUpgradeRoomModalOpen && (
				<BottomSheetModal
					isOpen={isUpgradeRoomModalOpen}
					onClose={() => setIsUpgradeRoomModalOpen(false)}
				>
					<div className="mb-4">
						<div className="text-lg font-semibold mb-2">Upgrade Room</div>
						<div className="text-gray-600 mb-4">
							Select a room to upgrade to:
						</div>
						{selectedAddOn &&
						Array.isArray(selectedAddOn.options) &&
						selectedAddOn.options.length > 0 ? (
							(() => {
								const validOptions = selectedAddOn.options.filter(
									(option) =>
										option &&
										option.roomNumber &&
										option.roomType &&
										option._id,
								);
								return validOptions.length > 0 ? (
									<div className="flex flex-col space-y-3">
										{validOptions.map((option) => (
											<label
												key={option._id}
												className="flex items-center space-x-2"
											>
												<input
													type="radio"
													name="upgradeRoomOption"
													value={option._id}
													checked={selectedUpgradeRoomOption === option._id}
													onChange={() =>
														setSelectedUpgradeRoomOption(option._id)
													}
													disabled={guest.roomNumber === option.roomNumber}
												/>
												<span
													className={`break-words ${guest.roomNumber === option.roomNumber ? "text-gray-400" : "text-gray-800"}`}
												>
													{option.roomNumber} - {option.roomType}
													{guest.roomNumber === option.roomNumber &&
														" (Current Room)"}
												</span>
											</label>
										))}
									</div>
								) : (
									<div className="text-gray-500">
										No upgrade options available.
									</div>
								);
							})()
						) : (
							<div className="text-gray-500">No upgrade options available.</div>
						)}
						<button
							className="mt-4 w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 disabled:opacity-50"
							onClick={handleUpgradeRoomSubmit}
							disabled={!selectedUpgradeRoomOption || isLoading}
						>
							{isLoading ? "Processing..." : "Send Request"}
						</button>
					</div>
				</BottomSheetModal>
			)} */}
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				transition={Bounce}
			/>
		</div>
	);
};

export default ServiceContainer;
